import { trackEvent } from 'tracking/tracking';
import { ExportViewEvent } from '@ardoq/export';

export const trackExportingVisualization = (metadata: ExportViewEvent) =>
  trackEvent('Exported visualization', metadata, true);
